import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { icon, image, title, price, features } = plan;

  return (
    <div className="plan-item">

      <div className='intro'>

        <img src={image} alt={title} /> {/* Plan Image */}

        <div className='content'>
          <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}
          <h3>{title}</h3> {/* Plan Title */}
          <div className="price">${price}</div> {/* Plan Price */}
        </div>

      </div>

      {/* List of Features */}
      <ul>
        {features.map((feature, index) => (
          <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
        ))}
      </ul>

      <Button link={"Get-Quote"} title={"Select Plan"} />

    </div>
  );
};

export default Plan;